<template>
    <div class="btn-group" role="group" aria-label="Banner image">
      <button type="button" class="btn btn-warning" v-if="!hasFile" @click="selectFile"><fa-icon icon="exclamation-triangle" class="mr-2" />Select {{getType}}</button>
      <button type="button" class="btn btn-success" v-if="hasFile" @click="selectFile"><fa-icon icon="check" class="mr-2" />Change {{getType}}</button>

      <div class="btn-group" role="group">
        <button id="buttonMenu" type="button" class="btn dropdown-toggle" v-bind:class="{ 'btn-success': hasFile, 'btn-secondary': !hasFile }" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <fa-icon icon="cog" />
        </button>
        <div class="dropdown-menu" aria-labelledby="buttonMenu">
        <!--
          <a class="dropdown-item" v-bind:class="{ 'disabled': !hasFile }" href="#"><fa-icon icon="eye" class="mr-2" /> Preview image</a>
        -->
          <a class="dropdown-item" v-bind:class="{ 'disabled': !hasFile, 'text-danger': hasFile }" href="#" @click="removeFile"><fa-icon icon="trash-alt" class="mr-2" /> Delete image</a>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        props: {
        	url: String,
        	type: String,
        	endpoint: String
		},
		data: function() {
			return {};
		},
		computed: {
            hasFile: function() {
                return this._props.url;
            },
            getType: function() {
            	return this._props.type || 'image';
            }
		},
		methods: {
            selectFile(e) {
                const input = document.createElement('input');
                input.type="file";
                input.onchange = (event) => {
                    const file = event.target.files[0];

                    this.$emit('file-selected', file);
                    this.uploadFile(file);
                };
                input.click();
            },
            removeFile(e) {
                e.preventDefault();
                if (!this._props.endpoint) return false;
                const url = this._props.endpoint  + '/' + this._props.url.split('/').pop();

                axios.delete(url)
                    .then((response) => {
            	       this.$emit('file-deleted');
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            uploadFile(file) {
                const reader = new FileReader();
                const url = this._props.endpoint;

                if (!url) return false;

                reader.onload = (e) => {
                    const data = e.target.result;
                    const filename = file.name;
                    axios.post(url, { filename, data })
                        .then((response) => {
                        	this.$emit('file-uploaded', response.data);
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                };

                reader.readAsDataURL(file);
            }            
		},
	};	
</script>